
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type KlaviyoDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function KlaviyoDialogRT(): TemplateResult<KlaviyoDialogRTRootProps> {
    function mergeProps(inline, external) {
        var res = Object.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function scopeVariantArrIdName2(klaviyoProduct, variant, variantIndex) {
        var variantArr = variant.split(';');
        var id = variantArr[0];
        var name = variantArr[1];
        return [_createElement('option', {
                'value': id,
                'data-variant-id': id,
                'key': '11261'
            }, name)];
    }
    function repeatVariant3(klaviyoProduct, variant, variantIndex, variantArr, id, name) {
        return scopeVariantArrIdName2.apply(this, [
            klaviyoProduct,
            variant,
            variantIndex
        ]);
    }
    function scopeKlaviyoProduct4() {
        var klaviyoProduct = window.Convermax.klaviyoModalActiveProduct;
        return _createElement('div', { 'id': 'container' }, _createElement('h3', mergeProps({ 'className': 'modal-title' }, { dangerouslySetInnerHTML: { __html: typeof klaviyoProduct.title === 'undefined' ? '' : klaviyoProduct.title } })), _createElement('p', {}, 'Register to receive a notification when this item comes back in stock.'), _createElement('form', {
            'action': '#',
            'className': 'form-horizontal clearfix'
        }, _createElement('div', { 'className': 'form-group' }, _createElement('div', {
            'id': 'variant_select',
            'className': 'col-sm-12' + (klaviyoProduct.variant_ids.length === 1 ? ' cm_hide' : '')
        }, _createElement.apply(this, [
            'select',
            {
                'id': 'variants',
                'className': 'selectpicker form-control input-lg'
            },
            !klaviyoProduct.variant_ids_fully ? _createElement('option', {
                'value': klaviyoProduct.variant_ids[0],
                'data-variant-id': klaviyoProduct.variant_ids[0],
                'key': '911'
            }, '\n                  Default Title\n                ') : null,
            _map(klaviyoProduct.variant_ids_fully, repeatVariant3.bind(this, klaviyoProduct))
        ]))), _createElement('div', { 'className': 'form-group' }, _createElement('input', {
            'required': true,
            'type': 'email',
            'id': 'email',
            'placeholder': 'Email',
            'className': 'form-control input-lg'
        }), _createElement('div', {
            'id': 'newsletter_subscription',
            'style': { display: 'none' }
        }, _createElement('p', {}, _createElement('input', {
            'type': 'checkbox',
            'id': 'subscribe_for_newsletter',
            'checked': true
        }), _createElement('label', { 'htmlFor': 'subscribe_for_newsletter' }, 'Add me to your email list.')))), _createElement('div', { 'className': 'klaviyo-button-container' }, _createElement('button', {
            'className': 'cm_klaviyo-dialog_btn add-to-cart button cta klaviyo-bis-trigger',
            'onClick': () => window.Convermax.addBackInStockSubscribe()
        }, _createElement('span', {}, 'Notify me when available'))), _createElement('div', {
            'id': 'error_message',
            'className': 'error_message alert alert-danger',
            'style': { display: 'none' }
        }), _createElement('div', {
            'id': 'completed_message',
            'className': 'completed_message alert alert-success',
            'style': { display: 'none' }
        }, '\n            You\'re in! We\'ll let you know when it\'s back.\n            ', _createElement('a', {
            'href': '#',
            'data-cm-role': 'close',
            'className': 'klaviyo-bis-close'
        }, 'Close'))), _createElement('p', { 'className': 'small-print' }));
    }
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'cm_dialog-title-container' }, _createElement('div', {
        'className': 'close klaviyo-bis-close',
        'data-cm-role': 'close'
    }, '\xD7')), _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'id': 'klaviyo-bis-modal' }, scopeKlaviyoProduct4.apply(this, []))));
}
        export const componentNames = []